import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom'

import apiLogActions from "../../../actions/apiLogActions";
import ApiLogInternalTable from "./ApiLogInternalTable";
import {DelayInput} from "react-delay-input";
import GeneralDialog from "../../common/GeneralDialog";
import {Input, Row} from "react-materialize";
import DialogBody from "../../common/KpnDialog/DialogBody";
import beautify from "xml-beautifier";
import Pagination from "../../../components/pagination/pagination";

class ApiLogTable extends Component {
    sortInitialState = {
        id: false,
        quotation: false,
        author: false,
        createdAt: false,
        updatedAt: false,
        status: false
    };

    tableHeaderNames = ["Logboek-ID", 'Offerte ID', 'Verzoektype', "Geïnitieerd door", "Aangemaakt", "Gewijzigd", "Succesvol", "Acties"];
    tableObjectProperties = ['id', 'quotationId', 'requestType', 'author', 'createdAt', 'updatedAt', 'status'];

    constructor(props) {
        super(props);
        this.state = {
            selectedApi: this.props.apiLogs.selectedApi,
            selectedApiLog: null,
            apiLogDialog: false,
            apiLogs: this.props.apiLogs.apiLogs || [],
            page: 1,
            searchPhrase: '',
            selectedLog: null,
            statusFilter: null,
            sorting: {
                ...this.sortInitialState
            },
        }
    }

    componentDidMount() {
        this.getAllApiLogs();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.apiLogs.selectedApi !== this.props.apiLogs.selectedApi) {
            this.setState({selectedApi: this.props.apiLogs.selectedApi});
            this.getAllApiLogs();
        }

        if (prevProps.apiLogs.apiLogs !== this.props.apiLogs.apiLogs) {
            this.setState({apiLogs: this.props.apiLogs.apiLogs});
        }
    }

    getAllApiLogs = (sortField, direction, page, searchQuery, statusFilter) => {
        const selectedApi = this.props.apiLogs.selectedApi;

        let queryParams = '';
        if (sortField && direction) {
            queryParams += '?sortField=' + sortField;
            queryParams += '&sortDirection=' + direction;
        }

        if (page) {
            queryParams += (queryParams.match(/\?/) ? '&' : '?');
            queryParams += 'page=' + page
        }
        if (searchQuery) {
            queryParams += (queryParams.match(/\?/) ? '&' : '?');
            queryParams += 'searchQuery=' + searchQuery;
        }
        if (statusFilter) {
            queryParams += (queryParams.match(/\?/) ? '&' : '?');
            queryParams += 'statusFilter=' + statusFilter;
        }

        this.props.apiLogActions.getAllApiLogs(selectedApi, queryParams);
    }

    onSearch = ({target}) => {
        let {name, value} = target;
        const searchPhrase = name === 'searchPhrase' ? value : '';

        const sortField = this.tableObjectProperties.find(x => this.state.sorting[x] !== false);
        const sortValue = this.state.sorting[sortField];

        this.setState({searchPhrase: searchPhrase});

        this.getAllApiLogs(
            sortField,
            sortValue,
            this.state.page,
            searchPhrase,
            this.state.statusFilter,
        );
    }

    onSortChange = ({target}) => {
        const headerName = target.getAttribute('headername');
        const propertyName = this.getHeaderPropertyForName(headerName);

        if (!propertyName) {
            return;
        }

        this.changeSortDirection(propertyName, this.getSortDirection(propertyName));
    };

    getSortDirection = (propertyName) => {
        const sortDirection = this.state.sorting[propertyName];
        switch (sortDirection) {
            case false:
                return "ASC";
            case "ASC":
                return "DESC";
            case "DESC":
                return false
        }
    };

    changeSortDirection = (propertyName, direction) => {
        this.setState({sorting: {...this.sortInitialState, [propertyName]: direction}});

        this.getAllApiLogs(propertyName, direction, this.state.page, this.state.searchPhrase, this.state.statusFilter)
    };

    changePage = ({target}) => {
        const {value} = target;
        this.setState({page: value});

        const sortField = this.tableObjectProperties.find(x => this.state.sorting[x] !== false);
        const sortValue = this.state.sorting[sortField];

        this.getAllApiLogs(sortField, sortValue, value, this.state.searchPhrase, this.state.statusFilter);
    };

    getHeaderPropertyForName = (displayName) => {
        const index = this.tableHeaderNames.indexOf(displayName);
        return this.tableObjectProperties[index];
    };

    renderContent = () => {
        const {selectedApi} = this.state;

        if (!selectedApi) {
            return (
                <div className="col s12">
                    <h1 className="admin-subheader-text">
                        <span className="ratio-section-title">Geen API geselecteerd. Om de logs weer te geven, selecteert u een API uit de lijst hierboven.</span>
                    </h1>
                </div>
            );
        }

        return this.renderApiLogTable();
    }

    renderPagination = () => {
        return (
            <div className="col s12 sendendform">
                <Pagination
                    page={this.props.apiLogs.currentPage}
                    pages={this.props.apiLogs.pages}
                    changePage={this.changePage}
                />
            </div>
        );
    }

    openLogDialog = (apiLogId) => {
        const {selectedApi} = this.state;
        this.props.apiLogActions.getApiLogDetails(selectedApi, apiLogId).then((response) => {
            if (response && response.success) {
                this.setState({selectedApiLog: response.apiLog});
            }
        }).then(() => {
            this.setState({apiLogDialog: true});
        })
    }

    closeLogDialog = () => {
        this.setState({selectedApiLog: null, apiLogDialog: false});
    }

    getActionsColumnForTable = (row) => {
        return (
            <div>
                <div>
                    <a href="#" onClick={() => this.openLogDialog(row.id)}>
                        <i className="small material-icons left themeprimarycolor">remove_red_eye</i>
                    </a>
                </div>
            </div>
        );
    };

    renderApiLogTable = () => {
        const {apiLogs, sorting} = this.state;

        return (
            <ApiLogInternalTable
                headersNames={this.tableHeaderNames}
                propertiesToShow={this.tableObjectProperties}
                rows={apiLogs}
                onHeaderClick={this.onSortChange}
                sortingState={sorting}
                actionsColumn={this.getActionsColumnForTable}
                getPropertyNameFromDisplayName={this.getHeaderPropertyForName}
            />
        );
    }

    renderDialogs = () => {
        const {apiLogDialog, selectedApi, selectedApiLog} = this.state;

        if (!apiLogDialog) {
            return;
        }

        switch (selectedApi) {
            case 'enreach':
                return this.renderEnreachApiLog(selectedApiLog);
            case 'yip':
                return this.renderYipApiLog(selectedApiLog);
            case 'connectWise':
                return this.renderConnectWiseApiLog(selectedApiLog);
            case 'nina':
                return this.renderNinaApiLog(selectedApiLog);
            case 'odido':
                return this.renderOdidoApiLog(selectedApiLog);
            default:
                return;
        }
    }

    renderEnreachApiLog = (selectedApiLog) => {
        return (
            <GeneralDialog
                dialogState={true}
                closeHandler={this.closeLogDialog}
                onRequestClose={this.closeLogDialog}
                headerText={'API-loggegevens'}
                headerIcon={'person'}
                dialogBodyContentRaw={
                    <DialogBody>
                        <form>
                            <Row>
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.id}
                                    label="ID"
                                    name='id'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.quotationId}
                                    label="Offerte ID"
                                    name='quotationId'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.status ? 'Succesvol' : 'Mislukt'}
                                    label="Succesvol"
                                    name='status'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.requestType}
                                    label="Verzoektype"
                                    name='requestType'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.createdBy}
                                    label="Geïnitieerd door"
                                    name='createdBy'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.createdAt}
                                    label="Aangemaakt"
                                    name='createdAt'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.updatedAt}
                                    label="Gewijzigd"
                                    name='updatedAt'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.orderProductId}
                                    label="Bestel product-ID"
                                    name='orderProductId'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-aanvraag-payload
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="request-payload"
                                        style={{height: 700}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.requestPayload, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-reactie
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="response"
                                        style={{height: 300}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.response, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-foutmelding
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="errorMessage"
                                        style={{height: 200}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.errorMessage, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                        </form>
                    </DialogBody>
                }
                rightButtonAction={() => this.closeLogDialog()}
                rightButtonText={'Sluiten'}
            />
        );
    }

    renderYipApiLog = (selectedApiLog) => {
        return (
            <GeneralDialog
                dialogState={true}
                closeHandler={this.closeLogDialog}
                onRequestClose={this.closeLogDialog}
                headerText={'API-loggegevens'}
                headerIcon={'person'}
                dialogBodyContentRaw={
                    <DialogBody>
                        <form>
                            <Row>
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.id}
                                    label="ID"
                                    name='id'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.quotationId}
                                    label="Offerte ID"
                                    name='quotationId'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.status ? 'Succesvol' : 'Mislukt'}
                                    label="Succesvol"
                                    name='status'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.requestType}
                                    label="Verzoektype"
                                    name='requestType'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.createdBy}
                                    label="Geïnitieerd door"
                                    name='createdBy'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.createdAt}
                                    label="Aangemaakt"
                                    name='createdAt'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.updatedAt}
                                    label="Gewijzigd"
                                    name='updatedAt'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-aanvraag-payload
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="request-payload"
                                        style={{height: 700}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.requestPayload, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-reactie
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="response"
                                        style={{height: 300}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.response, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-foutmelding
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="errorMessage"
                                        style={{height: 200}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.errorMessage, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                        </form>
                    </DialogBody>
                }
                rightButtonAction={() => this.closeLogDialog()}
                rightButtonText={'Sluiten'}
            />
        );
    }

    renderConnectWiseApiLog = (selectedApiLog) => {
        return (
            <GeneralDialog
                dialogState={true}
                closeHandler={this.closeLogDialog}
                onRequestClose={this.closeLogDialog}
                headerText={'API-loggegevens'}
                headerIcon={'person'}
                dialogBodyContentRaw={
                    <DialogBody>
                        <form>
                            <Row>
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.id}
                                    label="ID"
                                    name='id'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.quotationId}
                                    label="Offerte ID"
                                    name='quotationId'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.status ? 'Succesvol' : 'Mislukt'}
                                    label="Succesvol"
                                    name='status'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.requestType}
                                    label="Verzoektype"
                                    name='requestType'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.createdBy}
                                    label="Geïnitieerd door"
                                    name='createdBy'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.createdAt}
                                    label="Aangemaakt"
                                    name='createdAt'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.updatedAt}
                                    label="Gewijzigd"
                                    name='updatedAt'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-aanvraag-payload
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="request-payload"
                                        style={{height: 700}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.requestPayload, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-reactie
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="response"
                                        style={{height: 300}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.response, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-foutmelding
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="errorMessage"
                                        style={{height: 200}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.errorMessage, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                        </form>
                    </DialogBody>
                }
                rightButtonAction={() => this.closeLogDialog()}
                rightButtonText={'Sluiten'}
            />
        );
    }

    renderNinaApiLog = (selectedApiLog) => {
        return (
            <GeneralDialog
                dialogState={true}
                closeHandler={this.closeLogDialog}
                onRequestClose={this.closeLogDialog}
                headerText={'API-loggegevens'}
                headerIcon={'person'}
                dialogBodyContentRaw={
                    <DialogBody>
                        <form>
                            <Row>
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.id}
                                    label="ID"
                                    name='id'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.quotationId}
                                    label="Offerte ID"
                                    name='quotationId'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.status ? 'Succesvol' : 'Mislukt'}
                                    label="Succesvol"
                                    name='status'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.requestType}
                                    label="Verzoektype"
                                    name='requestType'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.createdBy}
                                    label="Geïnitieerd door"
                                    name='createdBy'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.createdAt}
                                    label="Aangemaakt"
                                    name='createdAt'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.updatedAt}
                                    label="Gewijzigd"
                                    name='updatedAt'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.orderProductId}
                                    label="Bestel product-ID"
                                    name='orderProductId'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-aanvraag-payload
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="request-payload"
                                        style={{height: 700}}
                                        readOnly={true}
                                    >
                                        {beautify(`${selectedApiLog.requestPayload}`)}
                                    </textarea>
                                </div>
                            </Row>
                            <Row>
                                <div className="col s12" style={{marginBottom: '20px'}}>
                                    API-reactie
                                </div>
                                <div className="col s12">
                                    <Input
                                        s={6}
                                        defaultValue={selectedApiLog.code}
                                        label="Antwoordcode"
                                        name='code'
                                        type='text'
                                        readOnly={true}
                                    />
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="response"
                                        style={{height: 200}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.response, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                            <Row>
                                <div className="col s12" style={{marginBottom: '20px'}}>
                                    API-reactie async
                                </div>
                                <div className="col s12">
                                    <Input
                                        s={6}
                                        defaultValue={selectedApiLog.asyncCode}
                                        label="Antwoordcode async"
                                        name='asyncCode'
                                        type='text'
                                        readOnly={true}
                                    />
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="asyncResponse"
                                        style={{height: 200}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.asyncResponse, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-foutmelding
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="errorMessage"
                                        style={{height: 200}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.errorMessage, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                        </form>
                    </DialogBody>
                }
                rightButtonAction={() => this.closeLogDialog()}
                rightButtonText={'Sluiten'}
            />
        );
    }

    renderOdidoApiLog = (selectedApiLog) => {
        return (
            <GeneralDialog
                dialogState={true}
                closeHandler={this.closeLogDialog}
                onRequestClose={this.closeLogDialog}
                headerText={'API-loggegevens'}
                headerIcon={'person'}
                dialogBodyContentRaw={
                    <DialogBody>
                        <form>
                            <Row>
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.id}
                                    label="ID"
                                    name='id'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.quotationId}
                                    label="Offerte ID"
                                    name='quotationId'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.pending ? 'Ja' : 'Nee'}
                                    label="Verzoek in behandeling"
                                    name='pending'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.finished ? 'Ja' : 'Nee'}
                                    label="Verzoek voltooid"
                                    name='finished'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={4}
                                    defaultValue={selectedApiLog.status ? 'Succesvol' : 'Mislukt'}
                                    label="Succesvol"
                                    name='status'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.requestType}
                                    label="Verzoektype"
                                    name='requestType'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.createdBy}
                                    label="Geïnitieerd door"
                                    name='createdBy'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.createdAt}
                                    label="Aangemaakt"
                                    name='createdAt'
                                    type='text'
                                    readOnly={true}
                                />
                                <Input
                                    s={6}
                                    defaultValue={selectedApiLog.updatedAt}
                                    label="Gewijzigd"
                                    name='updatedAt'
                                    type='text'
                                    readOnly={true}
                                />
                            </Row>
                            <Row>
                                <div className="col s12">
                                    API-foutmelding
                                </div>
                                <div className="input-field col s12">
                                    <textarea
                                        key={selectedApiLog.id}
                                        name="errorMessage"
                                        style={{height: 200}}
                                        readOnly={true}
                                    >
                                        {JSON.stringify(selectedApiLog.errorMessage, null, 4)}
                                    </textarea>
                                </div>
                            </Row>
                        </form>
                    </DialogBody>
                }
                rightButtonAction={() => this.closeLogDialog()}
                rightButtonText={'Sluiten'}
            />
        );
    }

    render() {
        return (
            <div className="row overviewkopbg ratiotable">
                <div className="col s12">
                    <h1 className="admin-subheader-text">
                        <span className="ratio-section-title">API-logboektabel</span>
                    </h1>
                </div>

                <div className="col s12 m3">
                    <div className="overviewkop">
                        <form>
                            <div className="input-field margingone inner-addon">
                                <i className="glyphicon tiny material-icons left lightgrey">search</i>
                                <DelayInput
                                    delayTimeout={800}
                                    id="search"
                                    type="search"
                                    name="searchPhrase"
                                    value={this.state.searchPhrase}
                                    onChange={this.onSearch}
                                />
                            </div>
                        </form>
                    </div>
                </div>

                {this.renderContent()}
                {this.renderPagination()}

                {this.renderDialogs()}
            </div>
        );
    }
}

const mapStateToProps = ({apiLogs}) => {
    return {
        apiLogs
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        apiLogActions: bindActionCreators(apiLogActions, dispatch),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ApiLogTable));
